"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusBroadCast = void 0;
var inversify_1 = require("inversify");
var bus_event_1 = require("./bus-event");
var consts_1 = require("./consts");
var utils_1 = require("./utils");
var BusBroadCast = /** @class */ (function () {
    function BusBroadCast(utils, busEvent) {
        this.utils = utils;
        this.busEvent = busEvent;
    }
    /**
     * 发送一次性通信消息，不等待返回
     * @param path 唯一标记
     * @param data 数据
     */
    BusBroadCast.prototype.emit = function (path, data) {
        path = "*:" + path;
        this.utils.sendToAll({ type: consts_1.MESSAGE_KEY, path: path, data: data });
    };
    /**
     * 广播事件监听
     * @param path 广播事件
     * @param handler 回调
     */
    BusBroadCast.prototype.listen = function (path, handler) {
        path = "*:" + path;
        return this.busEvent.on(path, handler);
    };
    /**
     * 移除广播监听
     * @param path 唯一标记
     * @param handler 绑定函数
     */
    BusBroadCast.prototype.remove = function (path, handler) {
        path = "*:" + path;
        return this.busEvent.off(path, handler);
    };
    BusBroadCast = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [utils_1.Utils,
            bus_event_1.BusEvent])
    ], BusBroadCast);
    return BusBroadCast;
}());
exports.BusBroadCast = BusBroadCast;
//# sourceMappingURL=bus-broadcast.js.map